import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { platform } from "@ids/tools";

@Component({
  selector: 'app-overview-data-not-editable',
  templateUrl: './overview-user-data-not-editable.component.html',
  styleUrls: ['./overview-user-data-not-editable.component.scss'],
})
export class OverviewUserDataNotEditableComponent extends DefaultPageComponent implements OnInit {

  headerId = 'overview-validated-not-editable';
  titlePage = 'Você precisa completar seus dados no itaú';
  nameNative = '';
  listStatus = [];
  labelBtnBack = 'Fechar';
  cameFromLogin: string;
  viewContent = false;
  loading = true;
  alertVoiceOver = false;
  ariaLabelPage = false;
  pendencias:string[];

  private analyticsGA4PagesModel: AnalyticsGA4PagesModel;

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public returnNativeService: ReturnNativeService,
    private title: Title,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPageGA4();
    this.listStatus = [
      {
        step: 'Dados de contato',
        status: this.profileCompleted() ? 'completo': 'pendente',
      },
      {
        step: 'Dados pessoais',
        status: this.journeyService.registratioJourney.data?.personalData?.isCompleted ? 'completo': 'pendente',
      },
      {
        step: 'Estado civil',
        status: this.journeyService.registratioJourney.data?.maritalStatus?.isCompleted ? 'completo': 'pendente',
      },
      {
        step: 'Endereço',
        status: this.journeyService.registratioJourney.data?.address?.isCompleted ? 'completo': 'pendente',
      },
      {
        step: 'Dados profissionais',
        status: this.journeyService.registratioJourney.data?.professionalData?.isCompleted ? 'completo': 'pendente',
      },
      {
        step: 'Renda e patrimônio',
        status: this.journeyService.registratioJourney.data?.incomeEquity?.isCompleted ? 'completo': 'pendente',
      }
    ]

    this.listStatus = this.listStatus.filter(x=>x.status == 'pendente')
  }

  profileCompleted(): boolean {
    if (this.journeyService.registratioJourney?.data?.profileData?.name !== undefined && 
        this.journeyService.registratioJourney?.data?.profileData?.name !== '' &&
        this.journeyService.registratioJourney?.data?.profileData?.email !== undefined && 
        this.journeyService.registratioJourney?.data?.profileData?.email !== '' &&
        this.journeyService.registratioJourney?.data?.profileData?.phoneNumber !== undefined && 
        this.journeyService.registratioJourney?.data?.profileData?.phoneNumber !== '') {
          return true;
      } else {
        return false;
      }
  }

  ngOnInit() {
    this.setTitle();
    this.focusPage(`#${this.headerId}`, 60);
  }

  ionViewWillEnter() {
    this.focusPage(`#${this.headerId}`, 60);
    this.sendTrackGA4LoadPage(this.analyticsGA4PagesModel.customPathCompletarDadosAppItau);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  getPageId(): string {
    return this.headerId;
  }

  backPage() {
    this.backJourney();
  }

  focusPage(selector: string, time: number) {
    if (platform.os === "IOS") {
      document.body.setAttribute("aria-hidden", "true");

      setTimeout(() => {
        document.body.removeAttribute("aria-hidden");
        this.focusElement(selector, time);
      }, 300);
    } else {
      this.focusElement(selector, time);
    }
  }

  focusElement(selector: string, time: number) {
    setTimeout(() => {
      const element = document.querySelector(selector) as HTMLElement;
      element?.focus();
    }, time);
  }

  getAnalyticsPageGA4() {
    this.analyticsGA4PagesModel = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  sendTrackGA4LoadPage(customPath: string) {
    const paramDefautl = {
      event_name: this.analyticsGA4PagesModel.eventNameScreenView,
      custom_path: customPath,
      implementation_team: this.analyticsGA4PagesModel.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }
}
